import { usePunditUserContext } from "@circle-react/contexts";

export const useIsCancelSubscriptionImmediatelyActionEnabled = (): boolean => {
  const { currentCommunitySettings } = usePunditUserContext();

  return Boolean(
    currentCommunitySettings?.paywalls_cancel_subscription_immediately_action_enabled,
  );
};
